import { lazy } from 'react';

export const FileUploadDropzone = lazy(async () => {
  const { FileUploadDropzone } = await import('./file-upload-dropzone');
  return { default: FileUploadDropzone };
});
